import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

const getMediaQuery = (): MediaQueryList | undefined => {
  let mediaQuery: MediaQueryList | undefined;

  if (typeof globalThis === 'object') {
    const candidate = globalThis as typeof globalThis & Partial<Window>;
    if (typeof candidate.matchMedia === 'function') {
      mediaQuery = candidate.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    }
  }

  return mediaQuery;
};

const computeIsMobile = () => {
  const mediaQuery = getMediaQuery();
  if (mediaQuery) {
    return mediaQuery.matches;
  }

  if (typeof globalThis === 'object') {
    const candidate = globalThis as typeof globalThis & Partial<Window>;
    if (typeof candidate.innerWidth === 'number') {
      return candidate.innerWidth < MOBILE_BREAKPOINT;
    }
  }

  return false;
};

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(computeIsMobile);

  React.useEffect(() => {
    const mediaQuery = getMediaQuery();
    if (!mediaQuery) {
      return;
    }

    const handleChange = () => {
      setIsMobile(computeIsMobile());
    };

    mediaQuery.addEventListener('change', handleChange);
    setIsMobile(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobile;
}
